import { clsx } from "clsx";

import ProfileImage from "common/components/ui/ProfileImage";
import Skeleton from "common/components/ui/Skeleton";
import type { Lead } from "common/types";

import FavoriteLead from "../FavoriteLead";

interface LeadHeadingProps {
  size: "md" | "lg";
  lead: Lead;
  isLoading: boolean;
}

export default function LeadHeading({
  size,
  lead,
  isLoading,
}: LeadHeadingProps) {
  return (
    <div
      className={clsx(
        "flex items-start",
        size === "lg" ? "gap-x-3" : "gap-x-2.5",
      )}
    >
      {isLoading ? (
        <Skeleton
          className={clsx(
            "rounded-full",
            size === "lg" ? "size-12" : "size-10",
          )}
        />
      ) : (
        <ProfileImage src={lead.picture_url} size={size} />
      )}

      <div
        className={clsx(
          "flex w-full flex-col ",
          size === "lg" ? "gap-y-0.5" : "gap-y-1",
        )}
      >
        {isLoading ? (
          <Skeleton className={clsx("w-24", size === "lg" ? "h-7" : "h-5")} />
        ) : (
          <div className="flex items-center gap-x-1">
            <span className={size === "lg" ? "text-lg-bold" : "text-md-bold"}>
              {lead.full_name}
            </span>
            {lead.is_lead && (
              <FavoriteLead
                leadId={lead.id}
                isLead={lead.is_lead}
                isFavorite={lead.favorite}
              />
            )}
          </div>
        )}

        {isLoading ? (
          <Skeleton className={clsx("w-40", size === "lg" ? "h-5" : "h-4")} />
        ) : (
          <span
            className={clsx(
              "text-black-500",
              size === "lg" ? "text-sm-medium" : "text-xs-medium",
            )}
          >
            {lead.occupation}
          </span>
        )}
      </div>
    </div>
  );
}
